import { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { Text, TextAreaInput, Icon } from 'common-components'
import SmartEditIcon from 'assets/svgr-icons/Smart_Edit.svg'
import debounce from 'lodash.debounce'
import { aiVideoThunks } from 'store/features/aiVideo/thunks'
import { dispatch } from 'store'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import * as Styled from './styled'

const MAX_CHARACTER_COUNT = 5000

interface ISmartPromptSectionProps {
  smartPrompt: string
}

const SmartPromptSection = memo(({ smartPrompt }: ISmartPromptSectionProps) => {
  const [prompt, setPrompt] = useState(smartPrompt)

  const debouncedChangeAction = useMemo(
    () =>
      debounce((value: string) => {
        dispatch(aiVideoThunks.setSmartPrompt(value))
      }, 400),
    []
  )

  const handleChange = useCallback(
    (value: string) => {
      setPrompt(value)
      debouncedChangeAction(value)
    },
    [debouncedChangeAction]
  )

  useEffect(() => {
    setPrompt(smartPrompt)
  }, [smartPrompt])

  return (
    <Styled.SmartPromptWrapper>
      <Styled.TitleWrapper>
        <Icon icon={<SmartEditIcon />} size="medium" color="secondaryDark" />
        <Text type="h2" fontWeight="600" color="secondaryDark">
          {translate(T.SMART_EDIT_LABEL)}
        </Text>
      </Styled.TitleWrapper>
      <TextAreaInput
        onChange={handleChange}
        placeholder={translate(T.SMART_EDIT_PLACEHOLDER)}
        value={prompt}
        minHeight={164}
        hasErrorOutline={prompt.length >= MAX_CHARACTER_COUNT}
        maxLength={MAX_CHARACTER_COUNT}
      />
    </Styled.SmartPromptWrapper>
  )
})

SmartPromptSection.displayName = 'SmartPromptSection'

export default SmartPromptSection
